import React, { useEffect, useState } from 'react'

import {
    useLocation
  } from "react-router-dom";

import {Grid} from '@mui/material'
import useStyles from './styles.js'
import Players from '../players/Players.js';
import Competitions from '../competitions/Competitions.js';
import FormPlayer from '../players/form/FormPlayer.js';
import FormCompetition from '../competitions/form/FormCompetition.js';
import Teams from '../teams/Teams.js';
import FormTeam from '../teams/form/FormTeam.js';
import FormMatch from '../matchs/form/FormMatch.js';
import Matchs from '../matchs/Matchs.js';
import Results from '../results/Results.js';
import Lives from '../lives/Lives.js';
import Calendar from '../calendar/Calendar.js';
import {isAdminUser, isReaderUser} from '../../actions/auth.js'
import MatchManagement from '../matchManagement/MatchManagement.js';
import FormLiveContainerCustom from '../lives/form/FormLiveContainerCustom.js';

const MainContainer = () => {
    const classes = useStyles();

    const location = useLocation();

    const [currentId, setCurrentId] = useState(null)

    useEffect(() => {
        setCurrentId(null)
    }, [location])

    return (<>

            { location.pathname==="/sports/lives" && <FormLiveContainerCustom currentId={currentId} setCurrentId={setCurrentId}></FormLiveContainerCustom>
            }

            {/* Calendar page */}
            {location.pathname==="/sports/calendriers" && 
            <Calendar />}
            
            <Grid className={classes.mainContainer} style={{marginTop : '0'}} container direction={['/match', '/sports/lives'].includes(location.pathname) ? "column-reverse" : "row"} alignItems="stretch" spacing={3}>
                {/* Result page */}
                {location.pathname==="/results" && 
                <Grid item xs={12} sm={12}><Results /></Grid>}
                {/* Match management page */}
                {location.pathname.includes("/matchmanagement") && 
                <Grid item xs={12} sm={12}><MatchManagement /></Grid>}
            
                
                {/* Specific pages bodies */}
                {location.pathname!=="/results" && location.pathname!=="/sports/calendriers" &&
                <><Grid item xs={12} sm={8}>
                    {location.pathname==="/competition" && <Competitions setCurrentId={setCurrentId}/>}
                    {location.pathname==="/player" && <Players setCurrentId={setCurrentId}/>}
                    {location.pathname==="/team" && <Teams setCurrentId={setCurrentId}/>}
                    {location.pathname==="/match" && <Matchs setCurrentId={setCurrentId}/>}
                    {location.pathname==="/sports/lives" && <Lives setCurrentId={setCurrentId} />}
                </Grid>

                {/* Specific pages headers */}
                {["/competition", "/player", "/team", "/match"].includes(location.pathname) && ( <Grid item xs={12} sm={4}>
                    {location.pathname==="/competition" && <FormCompetition currentId={currentId} setCurrentId={setCurrentId}/>}
                    {location.pathname==="/player" && <FormPlayer currentId={currentId} setCurrentId={setCurrentId}/>}
                    {location.pathname==="/team" && <FormTeam currentId={currentId} setCurrentId={setCurrentId}/>}
                    {location.pathname==="/match" && <FormMatch />}
                </Grid>)}
                </>
                }

            </Grid>
            </>
        )
}

export default MainContainer